export default __webpack_public_path__ + "static/4-contactus-919770f012179451efbc757551b4b6d1.jpg";